import { createContext } from 'react';

export interface ICacheContext {
  getApiModels: () => Promise<{ categories: any[]; models: any[] }>;
  setApiModels: any;
}

export const CacheContext = createContext({} as ICacheContext);
